export default {
  researcher: [
    {
      name: "خانه",
      url: "/researcher/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "حساب کاربری",
      url: "/researcher/profile",
      icon: "fa fa-user",
    },
    {
      name: "درخواست‌های کلان پروژه",
      url: "#",
      icon: "fa fa-tasks",
      children: [
        {
          name: "فعال",
          url: "/researcher/activeUnirequests",
          icon: "fa fa-check-circle",
        },
        {
          name: "غیرفعال",
          url: "/researcher/deactiveUnirequests",
          icon: "fa fa-times-circle",
        },
      ],
    },
    // {
    //   name: "درخواست‌ها",
    //   url: "#",
    //   icon: "fa fa-question-circle",
    //   children: [
    //     {
    //       name: "طرح",
    //       url: "#",
    //       icon: "fa fa-tasks",
    //       badge: {
    //         variant: "danger",
    //         text: "جدید",
    //       },
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeProposals",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveProposals",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedProposals",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "رساله دکتری",
    //       url: "#",
    //       icon: "fa fa-book",
    //       badge: {
    //         variant: "primary",
    //         text: "جدید",
    //       },
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activePhdThesis",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactivePhdThesis",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedPhdThesis",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "پایان‌نامه ارشد",
    //       url: "#",
    //       icon: "fa fa-book",
    //       badge: {
    //         variant: "success",
    //         text: "جدید",
    //       },
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeMasterThesis",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveMasterThesis",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedMasterThesis",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "مقالات",
    //       url: "/researcher/newArticle",
    //       icon: "fa fa-book",
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeArticle",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveArticle",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedArticle",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "فرصت مطالعاتی",
    //       url: "/researcher/newOpportunity",
    //       icon: "fa fa-book",
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeOpportunity",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveOpportunity",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedOpportunity",
    //         //   icon: "fa fa-check-square-o"
    //         // },
    //         // {
    //         //   name: "فرصت‌ها (بخش دوم)",
    //         //   url: "/researcher/completeOpportunity2",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "نشست‌های تخصصی",
    //       url: "/researcher/newMeeting",
    //       icon: "fa fa-book",
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeMeeting",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveMeeting",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedMeeting",
    //         //   icon: "fa fa-check-square-o"
    //         // },
    //         // {
    //         //   name: "نشست‌ها (بخش دوم)",
    //         //   url: "/researcher/newMeeting2",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "پسادکتری",
    //       url: "/researcher/newPostDoc",
    //       icon: "fa fa-book",
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activePostDoc",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactivePostDoc",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedPostDoc",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //     {
    //       name: "نخبگان وظیفه",
    //       url: "/researcher/newElite",
    //       icon: "fa fa-book",
    //       children: [
    //         {
    //           name: "فعال",
    //           url: "/researcher/activeElite",
    //           icon: "fa fa-check-circle",
    //         },
    //         {
    //           name: "غیرفعال",
    //           url: "/researcher/deactiveElite",
    //           icon: "fa fa-times-circle",
    //         },
    //         // {
    //         //   name: "تعیین تکلیف شده",
    //         //   url: "/researcher/decidedElite",
    //         //   icon: "fa fa-check-square-o"
    //         // },
    //         // {
    //         //   name: "نخبگان (بخش دوم)",
    //         //   url: "/researcher/newElite2",
    //         //   icon: "fa fa-check-square-o"
    //         // }
    //       ],
    //     },
    //   ],
    // },
    // {
    //   name: "درخواست جدید(ژنوم و مهندسی ژنتیک)",
    //   url: "/researcher/newRequest",
    //   icon: "fa fa-plus-circle",
    // },
    //  {
    //     name: "درخواست جدید",
    //     url: "/newRequestForm",
    //     icon: "fa fa-plus-circle",
    // },
    {
      name: "کنترل پروژه",
      url: "#",
      icon: "fa fa-map",
      children: [
        {
          name: "جدید",
          url: "/researcher/newPc",
          icon: "fa fa-map-o",
        },
        {
          name: "در حال انجام",
          url: "/researcher/goingPc",
          icon: "fa fa-map-o",
        },
        {
          name: "آرشیو ",
          url: "/researcher/archivePc",
          icon: "fa fa-map-o",
        },
      ],
    },
    {
      name: "گزارش خطا ",
      url: "/researcher/debug",
      icon: "fa fa-plus",
    },
    {
      name: "راهنما",
      url: "/researcher/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  referee: [
    {
      name: "خانه",
      url: "/referee/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "حساب کاربری",
      url: "/referee/profile",
      icon: "fa fa-user",
    },
    {
      name: "داوری‌ها",
      url: "/referee/reviews",
      icon: "fa fa-tasks",
    },
    {
      name: "آرشیو داوری‌ها",
      url: "/referee/archive",
      icon: "fa fa-check-circle",
    },
    {
      name: "کنترل پروژه",
      url: "#",
      icon: "fa fa-map",
      children: [
        {
          name: "گزارش‌ها",
          url: "/referee/projectsControl",
          icon: "fa fa-pencil-square",
        },
        {
          name: "انجام شده‌ها",
          url: "/referee/doneProjectsControl",
          icon: "fa fa-pencil-square",
        },
      ],
    },
    {
      name: "راهنما",
      url: "/referee/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  university: [
    {
      name: "خانه",
      url: "/university/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "ثبت طرح کلان",
      url: "/university/newUniRequest",
      icon: "fa fa-plus-circle",
    },
    {
      name: "درخواست‌های طرح کلان",
      url: "#",
      icon: "fa fa-list",
      children: [
        {
          name: "فعال",
          url: "/university/activeRequests",
          icon: "fa fa-book",
        },
        {
          name: "غیرفعال",
          url: "/university/inactiveRequests",
          icon: "fa fa-book",
        },
      ],
    },
    {
      name: "درخواست‌ها",
      url: "#",
      icon: "fa fa-list",
      children: [
        {
          name: "طرح‌",
          url: "/university/proposals",
          icon: "fa fa-book",
        },
        {
          name: "رساله دکتری",
          url: "/university/phds",
          icon: "fa fa-book",
        },
        {
          name: "پایان‌نامه ارشد",
          url: "/university/masters",
          icon: "fa fa-book",
        },
        {
          name: "مقالات",
          url: "/university/articles",
          icon: "fa fa-book",
        },
        {
          name: "فرصت مطالعاتی",
          url: "/university/opportunities",
          icon: "fa fa-book",
        },
        {
          name: "نشست‌های تخصصی",
          url: "/university/meetings",
          icon: "fa fa-book",
        },
        {
          name: "پسا دکتری",
          url: "/university/postDocs",
          icon: "fa fa-book",
        },
        {
          name: "نخبگان وظیفه",
          url: "/university/elites",
          icon: "fa fa-book",
        },
      ],
    },
    {
      name: "گالری تصاویر",
      url: "/university/images",
      icon: "fa fa-picture-o",
    },
    {
      name: "هیئت علمی",
      url: "/university/faculty",
      icon: "fa fa-users",
    },
    {
      name: "تغییر رمز عبور",
      url: "/university/changePassword",
      icon: "fa fa-lock",
    },
    {
      name: "راهنما",
      url: "/university/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  universityNotComplete: [
    {
      name: "خانه",
      url: "/university/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "تکمیل اطلاعات پژوهشی",
      url: "/university/complete",
      icon: "fa fa-check-square",
    },
    {
      name: "ثبت طرح کلان",
      url: "/university/newUniRequest",
      icon: "fa fa-plus-circle",
    },
    {
      name: "درخواست‌های طرح کلان",
      url: "#",
      icon: "fa fa-list",
      children: [
        {
          name: "فعال",
          url: "/university/activeRequests",
          icon: "fa fa-book",
        },
        {
          name: "غیرفعال",
          url: "/university/inactiveRequests",
          icon: "fa fa-book",
        },
      ],
    },
    {
      name: "تغییر رمز عبور",
      url: "/university/changePassword",
      icon: "fa fa-lock",
    },
    {
      name: "راهنما",
      url: "/university/guide",
      icon: "fa fa-question",
    },
    {
      name: "سوالات متداول",
      url: "/university/faq",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  company: [
    {
      name: "خانه",
      url: "/company/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "گالری تصاویر",
      url: "/company/images",
      icon: "fa fa-picture-o",
    },
    {
      name: "راهنما",
      url: "/company/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  accelerator: [
    {
      name: "خانه",
      url: "/accelerator/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "گالری تصاویر",
      url: "/accelerator/images",
      icon: "fa fa-picture-o",
    },
    {
      name: "حمایت‌های ثبت شده",
      url: "#",
      icon: "fa fa-check-square-o",
      children: [
        {
          name: "طرح پژوهشی",
          url: "/accelerator/registeredProposals",
          icon: "fa fa-check-square-o",
        },
        {
          name: "رساله دکتری",
          url: "/accelerator/registeredPhds",
          icon: "fa fa-check-square-o",
        },
        {
          name: "پایان‌نامه ارشد",
          url: "/accelerator/registeredMasters",
          icon: "fa fa-check-square-o",
        },
        {
          name: "فرصت مطالعاتی",
          url: "/accelerator/registeredOpportunities",
          icon: "fa fa-check-square-o",
        },
        {
          name: "پسا دکتری",
          url: "/accelerator/registeredPostDocs",
          icon: "fa fa-check-square-o",
        },
      ],
    },
    {
      name: "حمایت‌های در انتظار تجاری‌سازی",
      url: "/accelerator/waitingForCommercialization",
      icon: "fa fa-clock-o",
    },
    {
      name: "حمایت‌های در انتظار داوری",
      url: "/accelerator/reviews",
      icon: "fa fa-gavel",
    },
    {
      name: "تاریخچه داوری‌ها",
      url: "/accelerator/archiveReviews",
      icon: "fa fa-history",
    },
    {
      name: "گزارش‌های کنترل پروژه",
      url: "/accelerator/pcReports",
      icon: "fa fa-file-text-o",
    },
    {
      name: "گزارش‌های داوری شده",
      url: "/accelerator/doneProjectsControl",
      icon: "fa fa-check-square",
    },
    {
      name: "راهنما",
      url: "/accelerator/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  admin: [
    {
      name: "خانه",
      url: "/admin/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "امور اجرایی",
      url: "#",
      icon: "fa fa-tasks",
      children: [
        {
          name: "درخواست‌های جدید",
          url: "/admin/todo/registered",
          icon: "fa fa-envelope",
        },
        {
          name: "درخواست‌های در حال بررسی",
          url: "/admin/todo/underSupervision",
          icon: "fa fa-envelope-open",
        },
        {
          name: "درخواست‌های در دست داوری",
          url: "/admin/todo/inReview",
          icon: "fa fa-clock-o",
        },
        {
          name: "درخواست‌های داوری شده",
          url: "/admin/todo/reviewDone",
          icon: "fa fa-question-circle",
        },
        {
          name: "درخواست‌های اصلاح شده",
          url: "/admin/todo/corrected",
          icon: "fa fa-refresh",
        },
        {
          name: "درخواست‌های تایید شده",
          url: "/admin/todo/initialAccept",
          icon: "fa fa-check-square",
        },
        {
          name: "گزارش‌های جدید کنترل پروژه",
          url: "/admin/todo/newReports",
          icon: "fa fa-bolt",
        },
      ],
    },
    {
      name: "درخوااست‌های طرح کلان",
      url: "#",
      icon: "mdi mdi-notebook-outline",
      children: [
        {
          name: "درخواست‌های جدید",
          url: "/admin/uniRequests/registered",
          icon: "fa fa-envelope",
        },
        {
          name: "درخواست‌های نیازمند اصلاح",
          url: "/admin/uniRequests/incomplete",
          icon: "mdi mdi-clock-edit-outline",
        },
        {
          name: "درخواست‌های اصلاح شده",
          url: "/admin/uniRequests/corrected",
          icon: "mdi mdi-square-edit-outline",
        },
        {
          name: "درخواست‌های تایید شده",
          url: "/admin/uniRequests/accepted",
          icon: "fa fa-check-square",
        },
        {
          name: "تایید نهایی",
          url: "/admin/uniRequests/finalize",
          icon: "mdi mdi-check-decagram",
        },
        {
          name: "رد شده",
          url: "/admin/uniRequests/rejected",
          icon: "mdi mdi-cancel",
        },
      ],
    },
    {
      name: "درخوااست‌های ریزپروژه طرح کلان",
      url: "#",
      icon: "mdi mdi-notebook-outline",
      children: [
        {
          name: "درخواست‌های جدید",
          url: "/admin/researcherUniRequests/registered",
          icon: "fa fa-envelope",
        },
        {
          name: "درخواست‌های نیازمند اصلاح",
          url: "/admin/researcherUniRequests/incomplete",
          icon: "mdi mdi-clock-edit-outline",
        },
        {
          name: "درخواست‌های اصلاح شده",
          url: "/admin/researcherUniRequests/corrected",
          icon: "mdi mdi-square-edit-outline",
        },
        {
          name: "درخواست‌های تایید شده",
          url: "/admin/researcherUniRequests/accepted",
          icon: "fa fa-check-square",
        },
        {
          name: "تایید نهایی",
          url: "/admin/researcherUniRequests/finalize",
          icon: "mdi mdi-check-decagram",
        },
        {
          name: "رد شده",
          url: "/admin/researcherUniRequests/rejected",
          icon: "mdi mdi-cancel",
        },
      ],
    },
    {
      name: "درخواست‌های حوزه فعالیت",
      url: "#",
      icon: "mdi mdi-list-box",
      children: [
        {
          name: "درخواست‌های جدید",
          url: "/admin/demands/registered",
          icon: "fa fa-envelope",
        },
        {
          name: "درخواست‌های نیازمند اصلاح",
          url: "/admin/demands/incomplete",
          icon: "fa fa-clock-o",
        },
        {
          name: "درخواست‌های اصلاح شده",
          url: "/admin/demands/corrected",
          icon: "fa fa-refresh",
        },
        {
          name: "درخواست‌های تایید شده",
          url: "/admin/demands/accepted",
          icon: "fa fa-check-square",
        },
        {
          name: "نامه تاییدیه",
          url: "/admin/demands/letterSent",
          icon: "fa fa-envelope",
        },
        {
          name: "تایید نهایی",
          url: "/admin/demands/finalize",
          icon: "fa fa-check-square",
        },
        {
          name: "رد شده",
          url: "/admin/demands/rejected",
          icon: "mdi mdi-cancel",
        },
      ],
    },
    {
      name: "درخواست‌ها",
      url: "#",
      icon: "fa fa-list",
      children: [
        {
          name: "طرح‌ها",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeProposals",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveProposals",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedProposals",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditProposals",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledProposals",
              icon: "fa fa-check-square",
            },
            {
              name: "در انتظار تجاری‌سازی",
              url: "/admin/watingforCommercializingProposals",
              icon: "fa fa-check-square",
            },
          ],
        },

        // resale
        {
          name: "رساله دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activePhds",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archivePhds",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedPhds",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditPhds",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledPhds",
              icon: "fa fa-check-square",
            },
            {
              name: "در انتظار تجاری‌سازی",
              url: "/admin/watingforCommercializingPhds",
              icon: "fa fa-check-square",
            },
          ],
        },

        // arshad
        {
          name: "پایان‌نامه‌ ارشد",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeMasters",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveMasters",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedMasters",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditMasters",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledMasters",
              icon: "fa fa-check-square",
            },
            {
              name: "در انتظار تجاری‌سازی",
              url: "/admin/watingforCommercializingMasters",
              icon: "fa fa-check-square",
            },
          ],
        },

        // article
        {
          name: "مقالات",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeArticles",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveArticles",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedArticles",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditArticles",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledArticles",
              icon: "fa fa-check-square",
            },
          ],
        },

        // opportune
        {
          name: "فرصت مطالعاتی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeOpportunities",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveOpportunities",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedOpportunities",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditOpportunities",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledOpportunities",
              icon: "fa fa-check-square",
            },
            {
              name: "در انتظار تجاری‌سازی",
              url: "/admin/watingforCommercializingOpportunities",
              icon: "fa fa-check-square",
            },
          ],
        },

        // meetings
        {
          name: "نشست تخصصی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeMeetings",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveMeetings",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedMeetings",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditMeetings",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledMeetings",
              icon: "fa fa-check-square",
            },
          ],
        },

        // postDoc
        {
          name: "پسا دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activePostDocs",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archivePostDocs",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedPostDocs",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditPostDocs",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledPostDocs",
              icon: "fa fa-check-square",
            },
            {
              name: "در انتظار تجاری‌سازی",
              url: "/admin/watingforCommercializingPostDocs",
              icon: "fa fa-check-square",
            },
          ],
        },

        // elite
        {
          name: "نخبگان وظیفه",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/admin/activeElites",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/admin/archiveElites",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/admin/decidedElites",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/admin/needEditElites",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/admin/canceledElites",
              icon: "fa fa-check-square",
            },
          ],
        },
      ],
    },
    {
      name: "مدیریت کاربران",
      url: "#",
      icon: "fa fa-users",
      children: [
        {
          name: "پژوهشگران",
          url: "/admin/users",
          icon: "fa fa-book",
        },
        {
          name: "داوران",
          url: "/admin/reviewers",
          icon: "fa fa-graduation-cap",
        },
        {
          name: "دانشگاه‌ها",
          url: "/admin/universities",
          icon: "fa fa-university",
        },
        {
          name: "شرکت‌ها",
          url: "/admin/companies",
          icon: "fa fa-building",
        },
        {
          name: "شتاب‌دهنده‌ها",
          url: "/admin/accelerators",
          icon: "fa fa-building-o",
        },
        {
          name: "انجمن‌های دانشجویی",
          url: "/admin/organizations",
          icon: "fa fa-graduation-cap",
        },
      ],
    },
    {
      name: "کنترل پروژه",
      url: "#",
      icon: "fa fa-map",
      children: [
        {
          name: "جدید",
          url: "/admin/newPc",
          icon: "fa  fa-map-o",
        },
        {
          name: "در حال انجام",
          url: "/admin/goingPc",
          icon: "fa  fa-map-o",
        },
        {
          name: "آرشیو ",
          url: "/admin/archivePc",
          icon: "fa  fa-map-o",
        },
      ],
    },
    {
      name: "گزارش‌ها",
      url: "#",
      icon: "fa fa-bar-chart",
      children: [
        {
          name: "گزارش نموداری ",
          url: "/admin/reports",
          icon: "fa  fa-map-o",
        },
        {
          name: "گزارش پیشرفته ",
          url: "/admin/advancedReport",
          icon: "fa  fa-map-o",
        },
        {
          name: "گزارش فعالیت ",
          url: "/admin/systemVisits",
          icon: "fa  fa-map-o",
        },
      ],
    },
    {
      name: "تنظیمات سامانه",
      url: "#",
      icon: "fa fa-cogs",
      children: [
        {
          name: "موضوعات و محورها",
          url: "/admin/topics",
          icon: "fa fa-tasks",
        },
        {
          name: "دلایل رد درخواست",
          url: "/admin/rejectionType",
          icon: "fa fa-question-circle",
        },
        {
          name: "مدیریت شهر‌ها و استان‌ها",
          url: "/admin/citiesManagement",
          icon: "fa fa-map-pin",
        },
        {
          name: "تنظیمات نقشه",
          url: "/admin/mapSettings",
          icon: "fa fa-map-o",
        },
        {
          name: "تنظیمات بنرها",
          url: "/admin/banners",
          icon: "fa fa-image",
        },
      ],
    },
    {
      name: "ثبت سریع درخواست",
      url: "/admin/fastSubmission",
      icon: "fa fa-user-plus",
    },
    {
      name: "راهنما",
      url: "/admin/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  companyManager: [
    {
      name: "خانه",
      url: "/companyManager/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "شرکت‌ها",
      url: "/companyManager/companies",
      icon: "fa fa-building",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
    {
      name: "تغییر رمز عبور",
      url: "/companyManager/changepassword",
      icon: "fa fa-lock",
    },
  ],
  head: [
    {
      name: "خانه",
      url: "/head/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "درخواست‌ها",
      url: "#",
      icon: "fa fa-list",
      children: [
        {
          name: "طرح‌ها",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeProposals",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveProposals",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedProposals",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditProposals",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledProposals",
              icon: "fa fa-check-square",
            },
          ],
        },

        // resale
        {
          name: "رساله دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activePhds",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archivePhds",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedPhds",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditPhds",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledPhds",
              icon: "fa fa-check-square",
            },
          ],
        },

        // arshad
        {
          name: "پایان‌نامه‌ ارشد",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeMasters",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveMasters",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedMasters",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditMasters",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledMasters",
              icon: "fa fa-check-square",
            },
          ],
        },

        // article
        {
          name: "مقالات",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeArticles",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveArticles",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedArticles",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditArticles",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledArticles",
              icon: "fa fa-check-square",
            },
          ],
        },

        // opportune
        {
          name: "فرصت مطالعاتی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeOpportunities",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveOpportunities",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedOpportunities",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditOpportunities",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledOpportunities",
              icon: "fa fa-check-square",
            },
          ],
        },

        // meetings
        {
          name: "نشست تخصصی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeMeetings",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveMeetings",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedMeetings",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditMeetings",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledMeetings",
              icon: "fa fa-check-square",
            },
          ],
        },

        // postDoc
        {
          name: "پسا دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activePostDocs",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archivePostDocs",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedPostDocs",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditPostDocs",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledPostDocs",
              icon: "fa fa-check-square",
            },
          ],
        },

        // elite
        {
          name: "نخبگان وظیفه",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/head/activeElites",
              icon: "fa fa-check-square",
            },
            // {
            //   name: "پیشنویس",
            //   url: "/head/archiveElites",
            //   icon: "fa fa-check-square"
            // },
            {
              name: "تایید شده",
              url: "/head/decidedElites",
              icon: "fa fa-check-square",
            },
            {
              name: "نیازمند بازنگری",
              url: "/head/needEditElites",
              icon: "fa fa-check-square",
            },
            {
              name: "رد شده",
              url: "/head/canceledElites",
              icon: "fa fa-check-square",
            },
          ],
        },
      ],
    },
    {
      name: "مدیریت کاربران",
      url: "#",
      icon: "fa fa-users",
      children: [
        {
          name: "پژوهشگران",
          url: "/head/users",
          icon: "fa fa-book",
        },
        {
          name: "داوران",
          url: "/head/reviewers",
          icon: "fa fa-graduation-cap",
        },
        {
          name: " دانشگاه‌ها",
          url: "/head/universities",
          icon: "fa fa-university",
        },
      ],
    },
    {
      name: "گزارش‌ها",
      url: "#",
      icon: "fa fa-bar-chart",
      children: [
        {
          name: "گزارش نموداری ",
          url: "/head/reports",
          icon: "fa  fa-map-o",
        },
        {
          name: "گزارش پیشرفته ",
          url: "/head/advancedReport",
          icon: "fa  fa-map-o",
        },
      ],
    },
    {
      name: "تنظیمات",
      url: "#",
      icon: "fa fa-cogs",
      children: [
        {
          name: "موضوعات و محورها",
          url: "/head/topics",
          icon: "fa fa-tasks",
        },
        {
          name: "دلایل رد درخواست",
          url: "/head/rejectionType",
          icon: "fa fa-question-circle",
        },
        {
          name: "تغییر رمز عبور",
          url: "/head/changepassword",
          icon: "fa fa-lock",
        },
      ],
    },
    {
      name: "راهنما",
      url: "/head/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
  manager: [
    {
      name: "خانه",
      url: "/manager/dashboard",
      icon: "fa fa-home",
    },
    {
      name: "درخواست‌ها",
      url: "#",
      icon: "fa fa-list",
      children: [
        // proposal
        {
          name: "طرح‌ها",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeProposals",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveProposals",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedProposals",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needProposals",
              icon: "fa fa-list",
            },
          ],
        },

        // resale
        {
          name: "رساله دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activePhds",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archivePhds",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedPhds",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needPhds",
              icon: "fa fa-list",
            },
          ],
        },

        // arshad
        {
          name: "پایان‌نامه‌های ارشد",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeMasterProposals",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveMasterProposals",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedMasterProposals",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needMasterProposals",
              icon: "fa fa-list",
            },
          ],
        },

        // article
        {
          name: "مقالات",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeArticles",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveArticles",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedArticles",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needArticles",
              icon: "fa fa-list",
            },
          ],
        },

        // opportunity
        {
          name: "فرصت‌های مطالعاتی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeOpportunities",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveOpportunities",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedOpportunities",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needOpportunities",
              icon: "fa fa-list",
            },
          ],
        },

        // meeting
        {
          name: "نشست‌های تخصصی",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeMeetings",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveMeetings",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedMeetings",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needMeetings",
              icon: "fa fa-list",
            },
          ],
        },

        // postDoc
        {
          name: "پسا دکتری",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activePostDocs",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archivePostDocs",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedPostDocs",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needPostDocs",
              icon: "fa fa-list",
            },
          ],
        },

        // elite
        {
          name: "نخبگان وظیفه",
          url: "#",
          icon: "fa fa-list",
          children: [
            {
              name: "در دست بررسی",
              url: "/manager/activeElites",
              icon: "fa fa-list",
            },
            {
              name: "آرشیو",
              url: "/manager/archiveElites",
              icon: "fa fa-list",
            },
            {
              name: "تصمیم گیری شده",
              url: "/manager/decidedElites",
              icon: "fa fa-list",
            },
            {
              name: "نیاز به اقدام",
              url: "/manager/needElites",
              icon: "fa fa-list",
            },
          ],
        },
      ],
    },
    {
      name: "تغییر رمز عبور",
      url: "/manager/changepassword",
      icon: "fa fa-lock",
    },
    {
      name: "راهنما",
      url: "/manager/guide",
      icon: "fa fa-question",
    },
    {
      name: "نقشه تعاملی زیست فناوری",
      url: "/map",
      icon: "fa fa-map",
    },
  ],
};
